// src/components/App/AppBar.js

import React, { PureComponent } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";

import "./AppBar.css";
import getAssetBasePath from "./getAssetBasePath";

library.add(faPlus, faTimes);

class AppBar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mouseHover: false,
    };
  }

  getIcon(name) {
    switch (name) {
      case "my-portfolio-hub":
        return "PieLeftSlice.svg";
      case "model-performance":
        return "PortfolioCombo.svg";
      case "portfolio-analysis":
        return "ChartCombo.svg";
      case "fund-comparison":
        return "PieRightSlice.svg";
      case "capital-gains-comparison":
        return "Speedometer.svg";
      case "morningstar-ratings":
        return "Sunshine.svg";
      case "fibb":
        return "Barbell.svg";
      case "performance-at-a-glance":
        return "DoubleLineChart.svg";
      case "index-attribution":
        return "BarChart.svg";
      case "fund-attribution":
        return "FundAttribution.png";
      case "earnings":
        return "EarningsPath.png";
      case "custom-models":
        return "BarChartFilled.svg";
      case "models":
        return "PortfolioCombo.svg";
      case "chartaday":
        return "Growth.svg";
      default:
        return "";
    }
  }

  render() {
    const {
      title,
      description,
      name,
      divId,
      activeApp,
      selectCallback,
      // isFP,
      // isLoggedIn,
    } = this.props;

    const titleLink = "Watch this video for more information";
    let appStyle = "primaryBarStyle";
    let columnClass = "col-md-4";
    let iconHolderStyle = "iconHolderStyle";
    let titleStyle = "titleStyle";
    let titleStyleVideo = "titleStyleVideo";
    let aniStyle = "aniStyle";
    let closeStyle = "closeStyle";
    let iconStyle = "iconStyle";
    let iconStyle2 = "iconStyle2";

    if (activeApp === name) {
      appStyle = "primaryBarStyleOn";
      columnClass = "col-md-12";
      titleStyle = "titleStyleOn";
      titleStyleVideo = "titleStyleVideoOn";
      iconHolderStyle = "iconHolderStyleOn";
      aniStyle = "aniStyleOn";
      closeStyle = "closeStyleOn";
      if (window.matchMedia("(max-device-width: 1023px)").matches) {
        titleStyle = "titleStyleOnMobile";
      }
    } else if (activeApp !== "") {
      appStyle = "primaryBarStyleOff";
      columnClass = "col-md-4 col-sm-12";
    }

    const handleMouseEnter = () => {
      this.setState({ mouseHover: true });
    };

    const handleMouseLeave = () => {
      this.setState({ mouseHover: false });
    };

    const assetBasePath = getAssetBasePath();

    const iconSrc =
      activeApp === name
        ? `${assetBasePath}/iconsOn/${this.getIcon(name)}`
        : `${assetBasePath}/icons${
            this.state.mouseHover ? "On" : "Off"
          }/${this.getIcon(name)}`;

    return (
      <div className={columnClass + " " + aniStyle}>
        <div
          id={`${name}-header`}
          className={appStyle}
          role="button"
          tabIndex={0}
          aria-expanded={activeApp === name}
          aria-controls={divId}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              if (activeApp !== name) selectCallback(name);
            }
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={() => (activeApp === name ? null : selectCallback(name))}
        >
          {activeApp === name && (
            <div
              className={closeStyle}
              role="button"
              tabIndex={0}
              aria-label={`Close ${title}`}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  selectCallback(name);
                }
              }}
              onClick={() => {
                selectCallback(name);
              }}
            >
              <FontAwesomeIcon size="lg" icon="times" aria-hidden="true" />
            </div>
          )}
          <div className={iconHolderStyle}>
            <img
              className={iconStyle}
              src={iconSrc}
              alt={`${title} icon`}
              aria-hidden="true"
            />
          </div>
          <div className={titleStyle}>{title}</div>

          {activeApp === "fund-comparison" && (
            <div className={titleStyleVideo}>
              <a
                style={{ color: "white", background: "#0FACE7" }}
                href="https://www.wisdomtree.com/-/media/us-media-files/multimedia/Videos/2023_Fund_Comparison_Tool_Video.mp4"
                target="_blank"
                rel="noopener noreferrer"
              >
                {titleLink}
              </a>
            </div>
          )}
          {activeApp !== name && (
            <div className={"descriptionStyle"}>{description}</div>
          )}
          {activeApp === "" && (
            <div className={iconHolderStyle}>
              <img
                className={iconStyle2}
                src={`${assetBasePath}/icons${
                  this.state.mouseHover ? "Off" : "On"
                }/PlusSign.svg`}
                alt="Plus icon"
                aria-hidden="true"
              />
            </div>
          )}
        </div>

        {name === "capital-gains-comparison" &&
          activeApp === "capital-gains-comparison" && <div>&nbsp;</div>}
        <div
          className={activeApp === name ? "appOnStyle" : "appOffStyle"}
          id={divId}
          role="region"
          aria-labelledby={`${name}-header`}
        ></div>
      </div>
    );
  }
}

export default AppBar;



// WEBPACK FOOTER //
// ./src/components/App/AppBar.js